var moment = module.exports = require("./moment-timezone");
moment.tz.load(require('./data/packed/latest.json'));



//////////////////
// WEBPACK FOOTER
// D:/Work/Development/vsts_build/_work/2/s/web/node_modules/moment-timezone/index.js
// module id = zMA8
// module chunks = 1